import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import './index.scss'
import { AppView, AppViewWrapper } from '../../../components/AppView'

interface StoreProps {
  currentCompanyStore?: CurrentCompanyStore
}

@inject('currentCompanyStore')
@observer
export class DashboardProducts extends React.Component<React.PropsWithChildren<StoreProps>, {}> {
  render() {
    return this.props.children
  }
}
